const moment = require('moment')

export const dateFormat = (date, format) => {
  return date ? moment(date).format(format) : null
}